import {ItemResponseNodeBeanObject, ListResponseNodeBean, NodeBean, NodeControllerApi} from 'src/api/api';
import {BaseApi, configuration} from '../../../api/BaseApi';
import {processError} from '../../../api/customFetch';

class NodeApi extends BaseApi {
    api: NodeControllerApi;

    constructor() {
        super();
        this.api = new NodeControllerApi(configuration, configuration.basePath, this.customFetch);
    }

    all(): Promise<ListResponseNodeBean> {
        return this.api.nodeList().then(list => {
            return Promise.resolve(list);
        }).catch(err => {
            return processError(err);
        });
    }

    list(size: number = 20, page: number = 1, search?): Promise<ListResponseNodeBean> {
        try {
            let list = this.api.nodeList(search, {query: {size, page}});
            return Promise.resolve(list)
        } catch (err) {
            return processError(err);
        }
    }

    create(node: NodeBean): Promise<ItemResponseNodeBeanObject> {
        return this.api.createNode(node).then(created => {
            return Promise.resolve(created);
        }).catch(err => {
            return processError(err);
        });
    }

    edit(id: number, node: NodeBean): Promise<ItemResponseNodeBeanObject> {
        return this.api.editNode(node, id).then(updated => {
            return Promise.resolve(updated);
        }).catch(err => {
            return processError(err);
        });
    }

    view(id: number): Promise<ItemResponseNodeBeanObject> {
        return this.api.node(id).then(node => {
            return Promise.resolve(node);
        }).catch(err => {
            return processError(err);
        });
    }

    delete(id: number): Promise<void> {
        return this.api.deleteNode(id).then(() => {
            return Promise.resolve();
        }).catch(err => {
            return processError(err);
        });
    }
}

const nodeApi = new NodeApi();

export default nodeApi;
